module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.switchGroups), function(group, index) {
    return _c('div', {
      key: group.id,
      class: {
        'mb': index < (_vm.switchGroups.length - 1)
      }
    }, [_c('h4', [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('label.emergencyControll')) + ":")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleGroup(group, 23)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.openAll')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleGroup(group, 24)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.normal')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleGroup(group, 25)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.disableAll')))])], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((group.switches), function(switchx, index) {
      return _c('div', {
        key: switchx.id,
        staticClass: "switch-box",
        class: {
          'mb': index < (group.switches.length - 1)
        }
      }, [_c('div', {
        staticClass: "switch"
      }, [_vm._v(_vm._s(switchx.name))]), _vm._v(" "), _c('el-button', {
        on: {
          "click": function($event) {
            _vm.toggleSwitch(switchx, 23)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('button.open')))])], 1)
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-975891ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/SwitchControll.vue
// module id = 1178
// module chunks = 2